/**
* File faq-toggles.js
*
* Toggle/Collapse all FAQs.
*/
/* global faqi18n */
window.wdsToggleFAQs = {};
( function( window, app ) {

	app.faqsExpanded = false;

	// Constructor.
	app.init = function() {
		app.cache();
		app.bindEvents();
	};

	// Cache all the things.
	app.cache = function() {
		app.$c = {
			expandAll: document.getElementById( 'expand-all-faqs' ),
			faqButtons: document.querySelectorAll( '.wp-block-csccanada-faqs__list.accordion .accordion-header' )
		};
	};

	// Combine all events.
	app.bindEvents = function() {
		app.$c.expandAll.addEventListener( 'click', app.toggleAllFAQS );
	};

	// Expand all FAQs.
	app.toggleAllFAQS = function() {
		if ( ! app.faqsExpanded ) {
			app.$c.faqButtons.forEach( function( element ) {
				var faqContent = element.nextElementSibling;

				element.classList.add( 'is-active' );
				element.setAttribute( 'aria-expanded', true );
				faqContent.classList.add( 'is-active' );
				faqContent.setAttribute( 'aria-hidden', false );
			} );
		} else {
			app.$c.faqButtons.forEach( function( element ) {
				var faqContent = element.nextElementSibling;

				element.classList.remove( 'is-active' );
				element.setAttribute( 'aria-expanded', false );
				faqContent.classList.remove( 'is-active' );
				faqContent.setAttribute( 'aria-hidden', true );
			} );
		}
		app.toggleExpandButton();
	};

	// Toggle text on the expand button.
	app.toggleExpandButton = function() {
		if ( app.faqsExpanded ) {
			app.$c.expandAll.setAttribute( 'aria-label', faqi18n.expandAll );
			app.$c.expandAll.innerHTML = faqi18n.expand;

			app.faqsExpanded = false;
		} else {
			app.$c.expandAll.setAttribute( 'aria-label', faqi18n.collapseAll );
			app.$c.expandAll.innerHTML = faqi18n.collapse;

			app.faqsExpanded = true;
		}
	};

	// Toggle an attribute between true/false strings.
	app.toggleAttribute = function( el, attribute ) {
		const currentAttribute = el.getAttribute( attribute );

		'false' === currentAttribute ?
			el.setAttribute( attribute, 'true' ) :
			el.setAttribute( attribute, 'false' );
	};

	// Engage!
	app.init();

}( window, window.wdsToggleFAQs ) );
